var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClusters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(-6269 -3247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M6283.107,3258.893l1.781.353a1.818,1.818,0,1,0,.185-.917l-1.843-.366a2.915,2.915,0,0,0-.762-1.882l2.485-3.509a2.271,2.271,0,1,0-.764-.542l-2.455,3.468a2.918,2.918,0,0,0-3.564.558l-3.217-2.5a1.821,1.821,0,1,0-.6.718l3.295,2.56a2.92,2.92,0,0,0,.693,3.377l-1.974,2.792a2.416,2.416,0,1,0,.716.608l2.043-2.889a2.921,2.921,0,0,0,2.246.049l2.442,3.608a2.049,2.049,0,1,0,.762-.544l-2.4-3.541A2.936,2.936,0,0,0,6283.107,3258.893Zm3.593-.64a.88.88,0,1,1-.88.88A.88.88,0,0,1,6286.7,3258.253Zm-.85-9.088a1.328,1.328,0,1,1-1.328,1.328A1.328,1.328,0,0,1,6285.85,3249.165Zm-12.543,4.507a.879.879,0,1,1,.879-.879A.88.88,0,0,1,6273.307,3253.672Zm1.889,12.911a1.474,1.474,0,1,1,1.473-1.474A1.474,1.474,0,0,1,6275.2,3266.583Zm10.156-1.963a1.116,1.116,0,1,1-1.117,1.116A1.117,1.117,0,0,1,6285.352,3264.62Zm-5.045-4.582a1.992,1.992,0,0,1-1.989-1.989h0a1.989,1.989,0,1,1,1.989,1.989Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 22,
    height: 22,
    transform: "translate(6269 3247)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClusters);
export default __webpack_public_path__ + "static/media/icon-clusters.a573b7801797ec82a3d7e903a2a5575b.svg";
export { ForwardRef as ReactComponent };